export const messages = {
  en: {
    assetInventoryInStock: {
      title: 'Asset Inventory In Stock',
      warehouse: 'Warehouse',
      inventoryDate: 'Inventory Date',
      inventoryRemark: 'Inventory Remark',
      inStockProducts: 'In Stock Products',
      productId: 'ID',
      productName: 'Name',
      spec: 'Spec',
      price: 'Price',
      quantity: 'Quantity',
      inventoryQuantity: 'Inventory Quantity',
      willExpire: 'Will Expire',
      attrition: 'Attrition',
      inventoryProfit: 'Inventory Profit',
      inventoryLoss: 'Inventory Loss',
      profitAmount: 'Profit Amount',
      lossAmount: 'Loss Amount',
      status: 'Status',
      operation: 'Operation',
      back: 'Back',
      batchInStock: 'Batch In Stock',
      cancel: 'Cancel',
      noProductsToInStock: 'No products to in stock'
    }
  },
  zh: {
    assetInventoryInStock: {
      title: '资产盘点入库',
      warehouse: '选择仓库',
      inventoryDate: '盘点日期',
      inventoryRemark: '盘点说明',
      inStockProducts: '入库商品',
      productId: '编号',
      productName: '名称',
      spec: '规格',
      price: '单价',
      quantity: '账面数量',
      inventoryQuantity: '盘点数量',
      willExpire: '将过期',
      attrition: '耗损',
      inventoryProfit: '盘盈',
      inventoryLoss: '盘亏',
      profitAmount: '盘盈金额',
      lossAmount: '盘亏金额',
      status: '状态',
      operation: '操作',
      back: '返回',
      batchInStock: '批量入库',
      cancel: '取消',
      noProductsToInStock: '没有待入库的商品'
    }
  }
}